<p-toast />
<p-confirmdialog />
<ng-container *ngIf="authService.isAuthenticated(); else unAuth">
  <app-sidebar></app-sidebar>
  <div class="lg:pl-[278px]">
    <div class="px-5 py-5">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
<ng-template #unAuth>
  <router-outlet></router-outlet>
</ng-template>